import { useState, useEffect } from 'react'

import UserAppContext from '../../hook/UserAppContext'
import Home from './Home'
import Crush from './Crush'
import Photos from './Photos'
import Video from './Video'
import Modal from '../../components/modal/Modal'
import './pages.css'

const Main = ({isCurrent}) => {

      const [online, setOnline] = useState([])
      const [obj, setObj] = useState([])
      const [modal, setModal] = useState(false)
      const {user} = UserAppContext()
      const {infordata} = user.user 
      const id_xat = infordata.id_xat 
      const AVATAR = `https://api.dicebear.com/5.x/initials/svg?seed=${infordata.name}&font-size=26`

      async function getOnline(id){
            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ', err)
            }
      }

      useEffect(() => {
            getOnline(id_xat)
      }, [id_xat])

      return (
            <div className="main_content">
                  <div className="content_header">
                        <div className="main_header">
                              <div className="wrapper_online">
                                    <div className="online_avatar">
                                          <img src={infordata.avatar === '' ? AVATAR : infordata.avatar} alt={infordata.name} />
                                          <div className={online.status === 'online' ? "online_dots green" : "online_dots red"}></div>
                                    </div>
                                    <div className="online_data">
                                          <strong>{infordata.name}</strong>
                                          <p>{online.status === 'online' ? "Online Now" : "Offline"}</p>
                                          <span>{infordata.id_xat}</span>
                                    </div>
                              </div>
                        </div>
                  </div>
                  
                  <div className="pages">
                        <Home isCurrent={isCurrent} />
                        <Video isCurrent={isCurrent} />
                        <Crush isCurrent={isCurrent} />
                        <Photos isCurrent={isCurrent} isSetObj={setObj} isSetModal={setModal} />
                  </div>
                  <Modal isObj={obj} isModal={modal} isSetModal={setModal} />
            </div>
      )
}

export default Main
